import { TagPill } from "../components/tag-pill.tsx";

export type PropertyTagType =
  | "new"
  | "under-offer"
  | "exclusive"
  | "new-build"
  | "premium"
  | "featured"
  | "video"
  | "virtual-tour"
  | "closing-date";

const TypeToTextAndColour: Record<PropertyTagType, { text: string; colourClass: string }> = {
  new: { text: "New", colourClass: "bg-loch-500" },
  exclusive: { text: "Exclusive", colourClass: "bg-north-sea" },
  "new-build": { text: "New Build", colourClass: "bg-legacy-jungle" },
  "under-offer": { text: "Under Offer", colourClass: "bg-legacy-light-red" },
  "closing-date": { text: "Closing Date Set", colourClass: "bg-legacy-coral" },
  premium: { text: "Premium", colourClass: "bg-legacy-electric-purple" },
  featured: { text: "Featured", colourClass: "bg-legacy-pink" },
  video: { text: "Video", colourClass: "bg-legacy-teal-blue" },
  "virtual-tour": { text: "Virtual Tour", colourClass: "bg-legacy-teal-blue" },
};
export const PropertyTag = (props: { type: PropertyTagType; textOverride?: string }) => (
  <TagPill
    text={props.textOverride ?? TypeToTextAndColour[props.type].text}
    colourClass={TypeToTextAndColour[props.type].colourClass}
  />
);
